import { INITIAL_STATE } from './initialState';

const activationReducer = (
  state = INITIAL_STATE,
  { type, error, loading }
) => {
  switch (type) {
    case 'USER_ACTIVATION_TOKEN_STARTED':
      return {
        ...state,
        loading: true
      };
    case 'USER_ACTIVATION_TOKEN_FAILURE':
      return {
        ...state,
        error: error,
        loading: false
      };
    case 'USER_ACTIVATION_OTHER_FAILURE':
      return {
        ...state,
        error: error,
        loading: false
      };
    default:
      return state;
  }
};

export default activationReducer;
